<div class="settings-box-shadow">
  <ng-template #grammarPopContent>
    Automatically check and improve grammar across all websites when enabled.
  </ng-template>
  <h3 class="no-left-margin" style="margin-bottom: 0">
    FlyGrammar
    <vng-icon
      name="info"
      class="info-icon"
      color="accent"
      [outline]="false"
      [ngbPopover]="grammarPopContent"
      [closeDelay]="5000"
      triggers="mouseenter:mouseleave"
      placement="top"
    ></vng-icon>
  </h3>
  <ng-container *ngIf="adminOverride">
    <em>This setting is controlled by your administrator.</em>
  </ng-container>
  <p style="margin-top: 1em">Control whether FlyGrammar is active across all sites.</p>

  <vng-card variant="ghost" padding="none" style="margin-top: 10px" [formGroup]="form">
    <vng-toggle color="accent" [disabled]="adminOverride" formControlName="flyGrammar" label="Enable"
      style="margin-bottom: 10px"></vng-toggle>

    <vng-select
      *ngIf="flyGrammarEnabled"
      class="settings-fly-grammar-select-language"
      label="Select a default language"
      placeholder="Select a default language"
      [disabled]="adminOverride"
      formControlName="flyGrammarLanguage"
      [options]="languageOptions"
    ></vng-select>

    <!-- The remove-only blocked-domain chip row moved into the unified
         "Disabled Sites" manager (disabled-sites-settings), which can both add
         and remove sites across all four per-site lists. -->

    <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px"
      class="settings-fly-grammar-actions settings-card-actions">
      <button
        type="button"
        [disabled]="adminOverride || !isDirty || isSaving"
        vng-button
        variant="primary"
        (click)="save()"
        tabindex="-1"
      >
        Save
      </button>
    </div>
  </vng-card>
</div>
